export class AutoAccidentReport {
    id!: string
    indexId!: number
    incidentDateTime?: Date | string | null
    location?: string | null
    reportedByUserId?: string | null
    employeeTelephoneNumber?: string | null
    foremanSuperintendent?: string | null
    departmentInvolved?: string | null
    vehicleOrEquipmentNumber?: string | null
    dotClassification?: string | null
    drugTestPerformed = false
    policeDispatched = false
    policeCaseNumber?: string | null
    ticketIssuedTo?: string | null
    fireDispatched = false
    emsDispatched = false
    anyoneInjured = false
    injuredWho?: string | null
    anyoneTransported = false
    transportedWhere?: string | null
    typeOfInjuries?: string | null
    photosTakenAttached = false
    detailsOfWhatHappened?: string | null
    involvesThirdParty = false
    thirdPartyInformation?: string | null
    investigationRevealed?: string | null
    correctiveActions?: string | null
    disciplinaryActionGiven?: string | null
    employeeSignature?: string | null
    signedOn?: Date | string | null
    notes?: string | null
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean
    imageUrls: string[] = []
    imageFileNames: string[] = []

    // Populated by the API for grid display (not sent back on save).
    reportedByName?: string | null

    static createNew(): AutoAccidentReport {
        const report = new AutoAccidentReport()
        report.id = crypto.randomUUID()
        return report
    }
}
